import React from 'react';
import trashIcon from '../../../../../assets/image/delete.svg';
import PageLoader, { PageSmallLoader } from '../../../../../component/PageLoader';
import { FaEdit, FaTrash, FaBan, FaCheck } from 'react-icons/fa';
import { RiDeleteBinLine } from 'react-icons/ri';

export default function MeasuringUnitGeneral({
	measuringUnitList,
	measuringUnitLoader,
	handleDisable,
	handleDelete,
	handleOpenModel,
	sortDataList,
	sortIconMap,
	sortDirection,
}) {
	return (
		<div>
			{measuringUnitLoader.isLoader && measuringUnitLoader.isGetData ? (
				<PageLoader />
			) : (
				measuringUnitList && (
					<div
						className="m-2 lg-m-3"
						style={{
							position: 'fixed',
							height: 'calc(100% - 180px)',
							overflowY: 'auto',
							overflowX: 'hidden',
						}}
					>
						<table className="currency-table">
							<thead>
								<tr>
									{['NAME', 'STATUS', 'SHORT NAME', 'ACTIONS'].map((item, index) => (
										<th
											className="fs-5 fw-bold text-dark cursor-pointer"
											// style={{ border: '1px solid #E5E6E8' }}
											onClick={() => {
												if (item === 'NAME') {
													sortDataList({ order_by: 'name' });
												} else if (item === 'SHORT NAME') {
													sortDataList({ order_by: 'short_name' });
												} else if (item === 'STATUS') {
													sortDataList({ order_by: 'is_active' });
												}
											}}
										>
											<div className="d-flex align-items-center gap-4">
												{item}
												{item === 'NAME' && sortIconMap[sortDirection.name]}
												{item === 'STATUS' && sortIconMap[sortDirection.is_active]}
												{item === 'SHORT NAME' && sortIconMap[sortDirection.short_name]}
											</div>
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{measuringUnitList.map((data, index) => (
									<tr key={index}>
										<td
											className="fs-5 fw-light text-dark"
											style={{ border: '1px solid #E5E6E8' }}
										>
											{data.name}
										</td>
										<td
											className="fs-5 fw-light"
											style={{
												border: '1px solid #E5E6E8',
												color: data.is_active ? '#6AA247' : '#DC3545',
											}}
										>
											{data.is_active ? 'Active' : 'Inactive'}
										</td>
										<td
											className="fs-5 fw-light text-dark"
											style={{ border: '1px solid #E5E6E8' }}
										>
											{data.short_name}
										</td>
										<td className="text-center">
											<div className="d-flex gap-3 align-items-center">
												<div
													className="d-none d-lg-flex fs-6 fw-light rounded-3 py-2 px-4 bg-primary cursor-pointer text-white align-items-center"
													onClick={() => handleOpenModel(index)}
												>
													Edit
												</div>

												<div
													className="d-flex d-lg-none cursor-pointer text-primary"
													onClick={() => handleOpenModel(index)}
												>
													<FaEdit size={18} />
												</div>

												{measuringUnitLoader.isLoader &&
												measuringUnitLoader.isStatusId === data.id ? (
													<div
														className="text-center p-0"
														style={{ width: '65px', height: '20px' }}
													>
														<PageSmallLoader />
													</div>
												) : (
													<>
														<div
															className="d-none d-lg-flex fs-6 fw-light rounded-3 py-2 px-4 bg-primary cursor-pointer text-white align-items-center gap-2"
															onClick={() => {
																handleDisable(data.id, !data.is_active);
															}}
														>
															{data.is_active ? 'Disable' : 'Enable'}
														</div>

														<div
															className="d-flex d-lg-none cursor-pointer text-primary"
															onClick={() => handleDisable(data.id, !data.is_active)}
														>
															{data.is_active ? <FaBan size={18} /> : <FaCheck size={18} />}
														</div>
													</>
												)}
												{measuringUnitLoader.isLoader &&
												measuringUnitLoader.isDeleteId === data.id ? (
													''
												) : (
													<>
														<div className="d-none d-lg-flex cursor-pointer text-white align-items-center">
															<img
																src={trashIcon}
																width={20}
																height={20}
																className="cursor-pointer"
																onClick={() => handleDelete(data.id)}
																alt="arrow"
															/>
														</div>
														<div
															className="d-flex d-lg-none cursor-pointer text-danger"
															onClick={() => {
																if (
																	!measuringUnitLoader.isLoader &&
																	measuringUnitLoader.isDeleteId !== data.id
																) {
																	handleDelete(data.id);
																}
															}}
														>
															<RiDeleteBinLine size={18} />
														</div>
													</>
												)}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)
			)}
		</div>
	);
}
